import React from 'react';

class BannerLarge extends React.Component{
    render(){
        return(
            <div className="mt-3 mb-3">
                <div className="d-flex justify-content-center">
                    <a href={this.props.url} target="_blank" rel="noopener noreferrer">
                        <img src={this.props.image} className="img-fluid" alt={this.props.title} title={this.props.title}/>
                    </a>
                </div>
            </div>
        )
    }
}
export default BannerLarge;